import { Icon, SvgVideoLibrary } from '@loomhq/lens';
import classNames from 'classnames';
import React from 'react';

import ControlBarButton from '../control-bar-button';

import './styles.less';

export default function PipButton(props) {
  return (
    <ControlBarButton
      className={classNames('video-player-pip-button', {
        'crowded-embed': props.useEmojis,
      })}
      hoverTagText="Toggle PIP (p)"
      seeking={props.seeking}
      onClick={props.onClick}
    >
      <Icon
        className="control-bar-button-icon"
        color="white"
        icon={<SvgVideoLibrary />}
      />
    </ControlBarButton>
  );
}
